import { createSlice } from '@reduxjs/toolkit'
import {
  DYNAMIC_PAGE_GROUP_BRAND,
  DYNAMIC_PAGE_GROUP_CATEGORY, DYNAMIC_PAGE_GROUP_LIST, DYNAMIC_PAGE_GROUP_MONTH, DYNAMIC_PAGE_GROUP_OTHERS,
  DYNAMIC_TAB_LIST,
  ITEM_PER_PAGE_DYNAMIC_ITEMS,
  ITEM_TABS,
  LIST_MODE,
  SEARCH_MODE,
  SELECTED,
  TAB_ALL,
  TAB_BRANDS,
  TAB_DEFAULT,
  TAB_FOCUSED,
  TAB_PAGE,
  TAB_PRODUCTS,
  UNSELECTED,
} from '../../pages/dynamicUi/constants'
import { sortPagesData } from '../../helpers/helperFunctions'

const noItemsInTab = 3
const noItemsInStickyTab = 4
const dynamicItemTemplate = {
  pageData: {},
  meta: {
    total: -1,
    perPage: ITEM_PER_PAGE_DYNAMIC_ITEMS,
    page: 1,
  },
}

const dynamicItemListTemplate = {
  success: false,
  loading: false,
  error: '',
  [TAB_ALL]: { ...dynamicItemTemplate },
  [TAB_PRODUCTS]: { ...dynamicItemTemplate },
  [TAB_DEFAULT]: { ...dynamicItemTemplate },
  [TAB_BRANDS]: { ...dynamicItemTemplate },
  [TAB_FOCUSED]: { ...dynamicItemTemplate },
  [TAB_PAGE]: { ...dynamicItemTemplate },
  selected: TAB_ALL,
  tabs: Object.values(ITEM_TABS).slice(0, noItemsInTab),
  dropdownTabs: Object.values(ITEM_TABS).slice(noItemsInTab, ITEM_TABS.length),
}

const initialState = {
  isPlatformMobile: true,
  items: {
    flags: {
      deleting: false,
      deleteFlag: false,
    },
    [SELECTED]: { ...dynamicItemListTemplate },
    [UNSELECTED]: { ...dynamicItemListTemplate },
    activeTab: SELECTED,
    searchResult: {
      data: {},
      error: '',
      loading: false,
    },
  },
  mode: LIST_MODE,
  pages: {
    info: {
      data: {},
      loading: false,
      error: '',
      init: false,
    },
    tabs: {
      edit: {},
      selected: '',
      data: [],
      dropdowns: [],
      active: false,
    },
    modify: {
      adding: false,
    },
    [DYNAMIC_PAGE_GROUP_CATEGORY]: {
      data: {},
      loading: false,
      error: '',
      init: false,
    },
    [DYNAMIC_PAGE_GROUP_BRAND]: {
      data: {},
      loading: false,
      error: '',
      init: false,
    },
    [DYNAMIC_PAGE_GROUP_MONTH]: {
      data: {},
      loading: false,
      error: '',
      init: false,
    },
    [DYNAMIC_PAGE_GROUP_OTHERS]: {
      data: {},
      loading: false,
      error: '',
      init: false,
    },

    selectedGroup: DYNAMIC_PAGE_GROUP_MONTH,

  },

  selected: {
    template: {
      loading: false,
      error: '',
      data: [],
      init: false,
    },
  },
  addItems: {
    loading: false,
    error: '',
    success: false,
  },
  transferItems: {
    loading: false,
    error: '',
    success: false,
    flag: true,
  },
  bulkUpdate: {
    loading: false,
    error: '',
    flag: false,
  },
}

const dynamicUiSlice = createSlice({
  name: 'dynamicUi',
  initialState: initialState,
  reducers: {
    setDynamicPages: (state, action) => {
      const selectedGroup = action.payload.all ? 'info' : state.pages.selectedGroup

      if (action.payload.error) {
        state.pages[selectedGroup].error = action.payload.error
        state.pages[selectedGroup].loading = false
      } else if (action.payload.remove) {


        for (let i = 0; i < DYNAMIC_PAGE_GROUP_LIST.length; i++) {
          if (state.pages[DYNAMIC_PAGE_GROUP_LIST[i].value].data[action.payload.remove]) {
            delete state.pages[DYNAMIC_PAGE_GROUP_LIST[i].value].data[action.payload.remove]
          }

        }

        delete state.pages[DYNAMIC_PAGE_GROUP_MONTH].data[action.payload.remove]

        const allPages = Object.values(state.pages[selectedGroup].data)

        if (allPages.length) {
          state.pages.selectedPage = allPages[0].id
        }


      } else if (action.payload.data) {
        if (action.payload.all) {
          state.pages[selectedGroup].data = action.payload.data
        } else {
          const dontUpdateSelected = state.items.message

          if (dontUpdateSelected) {
            state.items.message = ''
          }

          //todo this contains some quick fix related pageId fix it and remove this todo
          const allData = action.payload.data.map((d) => ({ ...d, id: `a${d.id}` }))

          state.pages[selectedGroup].data = sortPagesData(allData)


          if (allData.length && !dontUpdateSelected) {
            const selectedPage = allData.find((d) => !d.deletable && d.type === 'HOMEPAGE') ?? allData.find((d) => !d.deletable) ?? allData[0]
            state.pages.selectedPage = selectedPage.id
          }
        }


        state.pages[selectedGroup].init = true
        state.pages[selectedGroup].loading = false
      } else if (action.payload.add) {

        const data = action.payload.add
        state.pages.selectedGroup = data.group
        state.pages.selectedPage = `a${data.id}`

        if (action.payload.editing) {
          if (state.pages[data.group].init) {
            state.pages[data.group].data[`a${data.id}`] = { ...data, id: `a${data.id}` }
          } else {
            state.items.message = 'do not update'
          }

          if (state.pages[DYNAMIC_PAGE_GROUP_MONTH].data[`a${data.id}`]) {
            state.pages[DYNAMIC_PAGE_GROUP_MONTH].data[`a${data.id}`] = { ...data, id: `a${data.id}` }
          }

          if (data.group !== selectedGroup && selectedGroup !== DYNAMIC_PAGE_GROUP_MONTH) {
            delete state.pages[selectedGroup].data[`a${data.id}`]
          }


        } else {

          if (state.pages[data.group].init) {
            state.pages[data.group].data = sortPagesData([{
              ...data,
              id: `a${data.id}`,
            }, ...Object.values(state.pages[data.group].data)])
          } else {
            state.items.message = 'do not update'
          }

          state.pages[DYNAMIC_PAGE_GROUP_MONTH].data = sortPagesData([{
            ...data,
            id: `a${data.id}`,
          }, ...Object.values(state.pages[DYNAMIC_PAGE_GROUP_MONTH].data)])
        }

        // if (action.payload.editing && selectedGroup !== data.group && selectedGroup !== DYNAMIC_PAGE_GROUP_MONTH) {
        //   delete state.pages[selectedGroup].data[`a${data.id}`];
        // }


      } else {
        state.pages[selectedGroup].loading = action.payload.loading ?? false
        state.pages[selectedGroup].error = ''
      }
    },
    setPageTabData: (state, action) => {

      if (action.payload.active) {

        const { add, deleted } = action.payload


        state.pages.tabs.active = true

        const _page = state.pages[state.pages.selectedGroup].data[state.pages.selectedPage]

        const pageTabs = _page.tabs ?? []

        const noOfVisibleItems = _page.is_vertical ? Infinity : noItemsInStickyTab;


        const updatedTabs = add ? [...pageTabs, add] : deleted ? pageTabs.filter((p) => p.id !== deleted) : pageTabs

        const tabData = [{ id: '' }, ...updatedTabs]

        const visibleTabs = tabData.slice(0, noOfVisibleItems)
        const nonVisibleTabs = tabData.slice(noOfVisibleItems, tabData.length)

        if (add && visibleTabs.find((t) => t.id !== add.id)) {
          //re-sync the values
          const removedItem = visibleTabs[visibleTabs.length - 1]

          state.pages.tabs.data = [...visibleTabs.slice(0, visibleTabs.length - 1), add]
          state.pages.tabs.dropdowns = nonVisibleTabs.map((item) => item.id === add.id ? removedItem : item)
        } else {
          state.pages.tabs.data = visibleTabs
          state.pages.tabs.dropdowns = nonVisibleTabs
        }


        state.pages.tabs.edit[''] = {}
        if (add || deleted) {
          //todo set tabs
          // state.pages.tabs.selected = action.payload.updated.id
          const selectedId = add?.id ?? ''
          state.pages.tabs.selected = selectedId

          state.pages.tabs.edit[selectedId] = add ? { ...add } : { id: '' }

          //update tabs
          state.pages[state.pages.selectedGroup].data[state.pages.selectedPage].tabs = updatedTabs
        }

      } else if (action.payload.update) {
        state.pages.tabs.data = state.pages.tabs.data.map((d) => d.id === action.payload.update.id ? action.payload.update : d)

        //update tabs
        state.pages[state.pages.selectedGroup].data[state.pages.selectedPage].tabs
          = state.pages[state.pages.selectedGroup].data[state.pages.selectedPage].tabs.map((d) => d.id === action.payload.update.id ? action.payload.update : d)
      } else if (action.payload.is_sticky_header !== undefined) {
        state.pages[state.pages.selectedGroup].data[state.pages.selectedPage].is_sticky_header = action.payload.is_sticky_header
      } else if (action.payload.is_vertical !== undefined) {
        state.pages[state.pages.selectedGroup].data[state.pages.selectedPage].is_vertical = action.payload.is_vertical

        //resync tabs as the number of visible tabs are different for vertical and non-vertical tabs. Note: This may not be required here as this case will not occur(because setting this is allowed only when there is no tabs)
        const _page = state.pages[state.pages.selectedGroup].data[state.pages.selectedPage]

        const pageTabs = _page.tabs ?? []

        const noOfVisibleItems = _page.is_vertical ? Infinity : noItemsInStickyTab;


        const tabData = [{ id: '' }, ...pageTabs]

        const visibleTabs = tabData.slice(0, noOfVisibleItems)
        const nonVisibleTabs = tabData.slice(noOfVisibleItems, tabData.length)

        state.pages.tabs.data = visibleTabs
        state.pages.tabs.dropdowns = nonVisibleTabs

      } else if (action.payload.selected) {

        if (action.payload.fromDropDown) {
          const removedItem = state.pages.tabs.data[state.pages.tabs.data.length - 1]
          const dropdownItem = state.pages.tabs.dropdowns.find((d) => d.id === action.payload.selected.id)

          state.pages.tabs.data = [...state.pages.tabs.data.slice(0, state.pages.tabs.data.length - 1), dropdownItem]
          state.pages.tabs.dropdowns = state.pages.tabs.dropdowns.map((item) => item.id === action.payload.selected.id ? removedItem : item)
        }

        state.pages.tabs.selected = action.payload.selected.id
        if (!state.pages.tabs.edit[action.payload.selected.id]) {
          state.pages.tabs.edit[action.payload.selected.id] = action.payload.selected
        }


      } else if (action.payload.edit) {
        if (action.payload.values.type) {
          delete state.pages.tabs.edit[state.pages.tabs.selected].value
          delete state.pages.tabs.edit[state.pages.tabs.selected].obj
          delete state.pages.tabs.edit[state.pages.tabs.selected].campaign_type
        }
        state.pages.tabs.edit[state.pages.tabs.selected] = { ...state.pages.tabs.edit[state.pages.tabs.selected], ...action.payload.values }

      } else {
        state.pages.tabs = { ...initialState.pages.tabs }
      }

    },
    setPagesAddingOrEditing: (state, action) => {

      if (action.payload.clear) {
        state.pages.modify = { ...initialState.pages.modify }
      }
      const selectedGroup = state.pages.selectedGroup
      if (action.payload.adding !== undefined) {
        state.pages.modify.adding = action.payload.adding
      } else if (action.payload.editing) {
        state.pages.modify.editing = state.pages[selectedGroup].data[state.pages.selectedPage]
      } else if (action.payload.deleting) {
        // state.pages.modify.deleting = action.payload.deleting;
        state.pages.modify.deleting = state.pages[selectedGroup].data[state.pages.selectedPage]
      }
    },
    setSelectedPage: (state, action) => {
      if (action.payload.clear) {
        state.pages.selectedPage = undefined
      } else {
        state.pages.selectedPage = action.payload.page
      }
    },
    setSelectedPageGroup: (state, action) => {

      state.pages.selectedGroup = action.payload.group
      if (Object.values(state.pages[state.pages.selectedGroup].data).length) {
        state.pages.selectedPage = Object.values(state.pages[state.pages.selectedGroup].data)[0].id
      }

    },
    bulkUpdateItems() {
    },

    setBulkUpdateLoading: (state, action) => {
      state.bulkUpdate.error = ''
      state.bulkUpdate.loading = action.payload
    },
    setBulkUpdateResult: (state, action) => {
      state.bulkUpdate.error = action.payload.error
      state.bulkUpdate.loading = false
      if (!action.payload.error) {
        state.bulkUpdate.flag = !state.bulkUpdate.flag
        state.selected[action.payload.id] = {
          ...(state.selected[action.payload.id] ?? initialState.selected.template),
          init: true,
          loading: false,
          error: '',
          data: action.payload.data,
        }
      }
    },
    //get items
    getAllItems() {
    },
    setItemsLoading: (state, action) => {
      const tab = state.items.activeTab
      const currentPage = state.items[tab][state.items[tab].selected].meta.page
      if (!state.items[tab][state.items[tab].selected].pageData[currentPage]) {
        state.items[tab][state.items[tab].selected].pageData[currentPage] = {}
      }
      state.items[tab][state.items[tab].selected].pageData[currentPage].error = ''
      state.items[tab][state.items[tab].selected].pageData[currentPage].loading = action.payload
    },
    updateFilter: (state, action) => {
      state.items.filter = action.payload
    },
    setGetItemsResult: (state, action) => {
      const currentPage = action.payload.page
      const tab = state.items.activeTab
      if (!state.items[tab][state.items[tab].selected].pageData[currentPage]) {
        return
      }

      state.items[tab][state.items[tab].selected].pageData[currentPage].error = action.payload.error
      state.items[tab][state.items[tab].selected].pageData[currentPage].loading = false
      if (!action.payload.error) {
        state.items[tab][state.items[tab].selected].pageData[currentPage].data = action.payload.data
        state.items[tab][state.items[tab].selected].pageData[currentPage].init = true
        state.items[tab][state.items[tab].selected].meta.total = action.payload.total_pages
        state.items[tab][state.items[tab].selected].meta.page = currentPage

      }
    },
    updateDynamicItemsPageNumber: (state, action) => {
      const tab = state.items.activeTab
      state.items[tab][state.items[tab].selected].meta.page = action.payload.page

    },
    updateDynamicItemsTab: (state, action) => {
      const tab = state.items.activeTab
      state.items[tab].selected = action.payload.tab.value

      if (action.payload.fromDropDown) {
        const removedItem = state.items[tab].tabs[state.items[tab].tabs.length - 1]
        state.items[tab].tabs = [...state.items[tab].tabs.slice(0, state.items[tab].tabs.length - 1), action.payload.tab]
        state.items[tab].dropdownTabs = state.items[tab].dropdownTabs.map((item) => item.value === action.payload.tab.value ? removedItem : item)
      }
    },
    resetItems: (state, action) => {
      if (action.payload?.preserveFilter) {
        state.items = { ...initialState.items, filter: state.items.filter }
      } else {
        state.items = { ...initialState.items }
      }

    },
    //get selected items
    getSelectedItems() {
    },
    setSelectedData: (state, action) => {
      if (action.payload.error) {
        if (!state.selected[action.payload.id]) return
        state.selected[action.payload.id].loading = false

        state.selected[action.payload.id].error = action.payload.error

      } else if (action.payload.data) {
        if (!state.selected[action.payload.id]) return
        state.selected[action.payload.id].init = true
        state.selected[action.payload.id].loading = false
        state.selected[action.payload.id].data = action.payload.data

      } else {
        if (!state.selected[action.payload.id]) {
          state.selected[action.payload.id] = { ...initialState.selected.template }
        }

        state.selected[action.payload.id].error = ''
        state.selected[action.payload.id].loading = action.payload.loading
      }
    },
    resetSelectedItems: (state, action) => {
      state.selected = { ...initialState.selected }
    },
    resetPlatform: (state, action) => {
      state.isPlatformMobile = initialState.isPlatformMobile
    },
    //add items
    addItems() {

    },
    setAddItemsLoading: (state, action) => {
      state.addItems.error = ''
      state.addItems.loading = action.payload
    },
    setAddItemsResult: (state, action) => {
      state.addItems.error = action.payload.error
      state.addItems.loading = false
      if (!action.payload.error) {
        // state.items.data = [action.payload, ...state.items.data];
        state.addItems.success = true
      }

    },
    setUpdateItemsResult: (state, action) => {
      state.addItems.error = action.payload.error
      state.addItems.loading = false
      const tab = state.items.activeTab
      if (!action.payload.error) {

        Object.keys(state.selected).forEach((key) => {
          state.selected[key].data = state.selected[key].data.map((datum) => datum.section.id === action.payload.id ? {
            ...datum,
            section: action.payload,
          } : datum)
        })

        if (state.mode === SEARCH_MODE) {
          state.items.searchResult.data = action.payload
        }

        const currentPage = state.items[tab][state.items[tab].selected].meta.page
        const currentPageData = state.items[tab][state.items[tab].selected].pageData
        if (currentPageData[currentPage]?.data) {
          state.items[tab][state.items[tab].selected] = {
            ...state.items[tab][state.items[tab].selected],
            pageData: {
              ...currentPageData,
              [currentPage]: {
                ...currentPageData[currentPage],
                data: currentPageData[currentPage].data.map((datum) => datum.id === action.payload.id ? action.payload : datum),
              },
            },
          }
        }

        // state.items.data = state.items.data.map((datum) => datum.id === action.payload.id ? action.payload : datum);
        state.addItems.success = true
      }

    },
    resetAddItems: (state, action) => {
      state.addItems = initialState.addItems
    },
    resetAddItemsData: (state, action) => {
      let allTabs = Object.keys(DYNAMIC_TAB_LIST)
      if (action.payload.except) {
        allTabs = allTabs.filter((t) => t !== action.payload.except)
      }
      for (let i = 0; i < allTabs.length; i++) {
        state.items[UNSELECTED][allTabs[i]] = { ...dynamicItemTemplate }
      }
    },
    resetCurrentTab: (state, action) => {
      const tab = state.items.activeTab
      state.items[tab][state.items[tab].selected] = { ...dynamicItemTemplate }

    },
    //end add items

    //delete items
    deleteItem() {

    },
    resetPages(state) {
      state.pages = { ...initialState.pages }
    },
    setItemsDeleting: (state, action) => {
      state.items.flags.deleting = action.payload
    },
    setDeleteItemsResult: (state, action) => {
      state.items.flags.deleting = false
      state.items.searchResult = { ...initialState.items.searchResult }
      // state.mode = LIST_MODE
      if (action.payload) {
        // state.items.data = state.items.data.filter(i => i.id !== action.payload);
        state.items.flags.deleteFlag = !state.items.flags.deleteFlag
      }
    },
    //delete items
    transferItem() {

    },
    tryAddOrUpdatePageTab(state, action) {

    },
    tryChangePageSettings(state, action) {

    },
    tryRemovePageTab(state, action) {

    },
    tryGetDynamicUiPages() {

    },
    tryAddOrUpdateDynamicUiPage() {

    },
    tryDeleteDynamicUiPage() {

    },
    setTransferLoading: (state, action) => {
      state.transferItems.loading = action.payload
    },
    setTransferItemsResult: (state, action) => {
      state.transferItems.loading = false
      if (action.payload.remove) {
        state.selected[action.payload.id].data = state.selected[action.payload.id].data.filter(i => i.section.id !== action.payload.sectionId)

        // state.selected.data = state.selected.data.filter(i => i.section.id !== action.payload.id);
      } else if (action.payload.update) {
        // state.selected.data = action.payload.data;
        state.selected[action.payload.id].data = action.payload.data
      } else {

        // state.selected.data = action.payload.data;
        state.selected[action.payload.id].data = action.payload.data

        // state.selected.data = state.selected.data.reduce((acc, curr) => {
        //   if (curr.priority < action.payload.data.priority) {
        //     const updated = [...acc, curr];
        //     updated[updated.length - 1] = updated[updated.length - 2];
        //     updated[updated.length - 2] = curr;
        //     return updated;
        //   } else {
        //     return [...acc, {...curr, priority: curr.priority + 1}];
        //   }
        // }, [action.payload.data]);

      }
      state.transferItems.flag = !state.transferItems.flag
      //Prevent user from resetting the page when product is added
      state.items.SELECTED = {
        ...dynamicItemListTemplate,
        [state.items.SELECTED.selected]: {
          ...dynamicItemTemplate,
          meta: {
            ...dynamicItemTemplate.meta,
            page: state.items.SELECTED[state.items.SELECTED.selected].meta.page
          }
        }
      }
      state.items.UNSELECTED = {
        ...dynamicItemListTemplate,
        [state.items.SELECTED.selected]: {
          ...dynamicItemTemplate,
          meta: {
            ...dynamicItemTemplate.meta,
            page: state.items.SELECTED[state.items.SELECTED.selected].meta.page
          }
        }
      }
    },
    togglePlatform(state, action) {
      state.isPlatformMobile = !state.isPlatformMobile
    },
    setActiveTab(state, action) {
      state.items.activeTab = action.payload.value
      if (action.payload.value === SELECTED) {
        state.items[UNSELECTED].selected = TAB_ALL
      } else {
        state.items[SELECTED].selected = TAB_ALL
      }
    },
    trySearchFocusItemSection() {
    },
    setSearchResult(state, action) {
      const { error, data } = action.payload
      if (error?.length) {
        state.items.searchResult.error = error
      } else {
        state.items.searchResult.data = data
      }
      state.items.searchResult.loading = false
    },
    setSearchResultLoading(state) {
      state.items.searchResult.loading = true
      state.items.searchResult.error = ''
      state.mode = SEARCH_MODE
    },
    resetSearchResult(state) {
      state.items.searchResult = { ...initialState.items.searchResult }
      state.mode = LIST_MODE

    },
  },
})


export const {
  getAllItems,
  setItemsLoading,
  resetItems,
  setGetItemsResult,
  addItems,
  resetAddItems,
  setAddItemsLoading,
  setAddItemsResult,
  setUpdateItemsResult,
  deleteItem,
  setDeleteItemsResult,
  setItemsDeleting,
  getSelectedItems,
  resetSelectedItems,
  resetPlatform,
  transferItem,
  setTransferLoading,
  setTransferItemsResult,
  updateFilter,
  bulkUpdateItems,
  setBulkUpdateLoading,
  setBulkUpdateResult,
  togglePlatform,
  tryGetDynamicUiPages,
  setDynamicPages,
  setPagesAddingOrEditing,
  tryAddOrUpdateDynamicUiPage,
  tryDeleteDynamicUiPage,
  setSelectedPage,
  setSelectedData,
  updateDynamicItemsPageNumber,
  updateDynamicItemsTab,
  resetAddItemsData,
  resetCurrentTab,
  setSelectedPageGroup,
  resetPages,
  setActiveTab,
  trySearchFocusItemSection,
  setSearchResultLoading,
  setSearchResult,
  resetSearchResult,
  setPageTabData,
  tryAddOrUpdatePageTab,
  tryRemovePageTab,
  tryChangePageSettings
} = dynamicUiSlice.actions

export default dynamicUiSlice.reducer


const dummyTabs = [
  { id: '' },
  {
    'id': 'someee',
    title: 'Acnes',
    image_url: 'https://pixlr.com/images/generator/photo-generator.webp',
    type: 'BRAND',
    value: '50',
  },
  {
    'id': 'someee2',
    title: 'Page',
    image_url: 'https://pixlr.com/images/generator/image-editor.webp',
    type: 'PAGE',
    value: '421ef4',
  },
  {
    'id': 'someee3',
    title: 'Cat Bread Oil',
    image_url: 'https://pixlr.com/images/generator/simple-generator.webp',
    type: 'CATEGORY',
    value: '164',
  },
  {
    'id': 'someee4',
    title: 'Brand BLove',
    image_url: 'https://pixlr.com/images/generator/light-source.webp',
    type: 'BRAND',
    value: '396',
  },
  {
    'id': 'someee4',
    title: 'Page Gold Partners',
    image_url: 'https://pixlr.com/images/generator/photo-generator.webp',
    type: 'PAGE',
    value: 'cc1afc',
  },
]
